import { RecommendationSuccessResultCreator } from '../index';
export class RecommendationsRequestBroker {
  extract(response) {
    var _response$recommendat, _response$recommendat2;
    return (_response$recommendat = response === null || response === void 0 ? void 0 : (_response$recommendat2 = response.recommendations) === null || _response$recommendat2 === void 0 ? void 0 : _response$recommendat2.data) !== null && _response$recommendat !== void 0 ? _response$recommendat : [];
  }
  getSuccessResultCreator(response, result) {
    return new RecommendationSuccessResultCreator(response, result);
  }
}